import { GetAsync } from "../actions";

export const getDashboardAlerts= async ()=>{
    return GetAsync({},"Dashboard/DashBoardAlerts");
}

export const getDashboardSystemSetupProgress= async ()=>{
    return GetAsync({},"Dashboard/DashboardSystemSetupProgress");
}